module.exports = __webpack_public_path__ + "img/parceiro2.24cc3178.png";